export interface IGenericErrorState {
    title: string
    subText: string
    route?: string
    errors?: string[]
}

export const initGenericErrorState: IGenericErrorState = {
    title: '',
    subText: '',
    route: '',
    errors: [],
}